import {useLocation} from "react-router-dom";

export default function FormButtons({handleSubmit, handleRemoveModal}) {

    const {pathname} = useLocation();
    return (
        <div className="buttons-container">
            { !pathname?.includes("nouveau") && 
                <button type="button" className="red-button" onClick={handleRemoveModal}>
                    <i className="fa fa-xmark"></i>
                    <span>Annuler</span>
                </button>
            }
            <button type="submit" className="green-button">
                <i className="fa fa-check"></i>
                <span>Enregistrer</span>
            </button>
        </div>
    )
}